import script from "./HomePageAlignmentReport.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageAlignmentReport.vue?vue&type=script&setup=true&lang=js"

import "./HomePageAlignmentReport.vue?vue&type=style&index=0&id=2d8eeefc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8eeefc"]])

export default __exports__